<script setup lang="ts">
defineSlots<{
  /** The chip's content: a site icon and a short name; wrap the name in `truncate` to clip a long one. */
  default(): unknown
}>()
</script>

<template>
  <span
    class="icon-sm inline-flex h-12 max-w-(--container-rail-chip) shrink-0 items-center gap-2 rounded-full bg-bg-primary pr-4 pl-2 text-caption whitespace-nowrap text-text-primary shadow-1 inset-shadow-glass-edge"
  >
    <slot />
  </span>
</template>
